import { render, staticRenderFns } from "./picture_config.vue?vue&type=template&id=3427e546&"
import script from "./picture_config.vue?vue&type=script&lang=js&"
export * from "./picture_config.vue?vue&type=script&lang=js&"
import style0 from "./picture_config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports